import { memo } from "react";
import { Companies } from "../../../model/info-about-bootcamp";

interface Props {
  data: Companies;
}

export const AfterBootcamp = memo<Props>(({ data }) => {
  return (
    <div>
      <div className="pt-24 lg:pt-46 border-t-2 border-solid border-[#22282B] mr-5 ml-5 lg:mr-auto lg:ml-auto lg:pr-20 lg:pl-20 pb-6 text-center lg:text-[20px] max-w-[1440px] m-auto lg:leading-[25px] text-night-base-base-400">
        {data.title}
      </div>
      <h3 className="pr-5 pl-5 lg:pr-20 lg:pl-20 pb-20 lg:pb-24 text-center text-white text-[20px] max-w-[1440px] m-auto leading-[25px] lg:text-[38px] lg:leading-[38px]">
        {data.subtitle}
      </h3>
      <div className="max-w-[1680px] m-auto overflow-hidden">
        <div className="flex pb-4">
          {data.list.map((item, index) => (
            <div
              key={index}
              className="mr-4 lg:mr-5 w-fit rounded-[32px] bg-night-background pt-5 pb-5 pl-8 pr-8 lg:pt-8 lg:pb-8 lg:pl-16 lg:pr-16"
            >
              <div // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: item.title,
                }}
                className="text-white"
              />
            </div>
          ))}
        </div>
        <div className="relative left-[-50px] flex pb-4">
          {data.list2.map((item, index) => (
            <div
              key={index}
              className="mr-4 lg:mr-5 w-fit rounded-[32px] bg-night-background pt-5 pb-5 pl-8 pr-8 lg:pt-8 lg:pb-8 lg:pl-16 lg:pr-16"
            >
              <div // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: item.title,
                }}
                className="text-white"
              />
            </div>
          ))}
        </div>
        <div className="flex pb-37 lg:pb-[127px]">
          {data.list3.map((item, index) => (
            <div
              key={index}
              className="mr-4 lg:mr-5 w-fit rounded-[32px] bg-night-background pt-5 pb-5 pl-8 pr-8 lg:pt-8 lg:pb-8 lg:pl-16 lg:pr-16"
            >
              <div // eslint-disable-next-line
                dangerouslySetInnerHTML={{
                  __html: item.title,
                }}
                className="text-white"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});
